// src/components/Charts/EmployeeChart.js

import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import api from '../../../../api';

const EmployeeChart = () => {
  const [series, setSeries] = useState([0, 0]);
  const [availableEmployeesCount, setAvailableEmployeesCount] = useState(0);
  const [assignedEmployeesCount, setAssignedEmployeesCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEmployeeData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get('/current-capacity-usage', {
        params: { asset_id: 1 },
      });

      const { availableEmployeesCount, assignedEmployeesCount } = response.data;

      setAvailableEmployeesCount(availableEmployeesCount || 0);
      setAssignedEmployeesCount(assignedEmployeesCount || 0);
      setSeries([availableEmployeesCount || 0, assignedEmployeesCount || 0]);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch employee data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, []);

  const options = {
    labels: ['Available', 'Assigned'],
    chart: {
      type: 'donut',
      height: '100%',
      width: '100%',
      fontFamily: 'Plus Jakarta Sans, sans-serif',
      foreColor: '#adb0bb',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '85%',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '16px',
              fontWeight: 600,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: '14px',
              fontWeight: 500,
              offsetY: 10,
              formatter: (val) => `${val}%`,
            },
            total: {
              show: false,
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: false },
    legend: { show: false },
    colors: ['#11DEB9', '#FA9479'],
    tooltip: {
      theme: 'dark',
      fillSeriesColor: false,
    },
  };

  return (
    <div className="text-center">
      <div id="employee-chart" className="w-full h-64 flex items-center justify-center">
        {loading ? (
          <span>Loading...</span>
        ) : error ? (
          <span className="text-red-500">{error}</span>
        ) : (
          <Chart options={options} series={series} type="donut" height="100%" />
        )}
      </div>

      {!loading && !error && (
        <div className="employee-donut-panel mx-auto" style={{ width: '100%', maxWidth: '250px' }}>
          <div className="mt-2 text-center">
             <h5 className="fw-semibold mb-4">Employee Capacity Usage</h5>
            <p>Available: {availableEmployeesCount}</p>
            <p>Assigned: {assignedEmployeesCount}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeChart;
